/**
 * Web entry point — loaded ONLY by webpack.
 * Metro (Android) resolves index.js first and never touches this file.
 *
 * Differences from index.js:
 *  - No `react-native-gesture-handler` early import (the web build
 *    of gesture-handler does not require a pre-registration step).
 *  - Wraps <App> in <GestureHandlerRootView> so react-navigation
 *    gesture-based navigators work on the web.
 *  - Uses AppRegistry.runApplication to mount into the DOM.
 */

import { AppRegistry } from 'react-native';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import React from 'react';
import App from './App';
import appJson from './app.json';

const appName = appJson.name;

const WebApp = () =>
  React.createElement(
    GestureHandlerRootView,
    { style: { flex: 1 } },
    React.createElement(App, null),
  );

AppRegistry.registerComponent(appName, () => WebApp);

const rootTag =
  document.getElementById('root') || document.getElementById('app');

AppRegistry.runApplication(appName, { rootTag });
